<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/21EGet/images/cover.jpg?1701060818265" alt="This image is the cover for the book Comfort Knitting & Crochet: Babies & Toddlers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Comfort Knitting & Crochet: Babies & Toddlers
      </h1>
      <p class="bookDescription body article font2">
        <b>Handmade gifts for little ones, from blankets to bonnets to toys.</b><br/>  <br/> Nary a knitter or crocheter can resist making soft, snuggly things for babies. In <i>Comfort Knitting &amp; Crochet: Babies &amp; Toddlers</i>, the Berroco design team (led by superstar design director Norah Gaughan) cover all of the cozy bases, presenting blankets, sweaters, bonnets, and plush toys. Like the first book in the Comfort series—<i>Comfort Knitting &amp; Crochet: Afghans</i>—this one features 50 knit and crochet projects using the company’s bestselling, affordably priced Comfort and Vintage yarns. With project styles ranging from traditional pastels and Aran knits to midcentury modern color-blocking, and challenge levels ranging from beginner to advanced, there’s something for every knitter and crocheter—and every baby they love—in this beautiful collection.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Norah Gaughan, Berroco Design Team, Ericka McConnell
      </h2>
      
      <p class="authorDescription body article">Norah Gaughan, author of STC&rsquo;s&#160;<I>Knitting Nature</I>&#160;and&#160;<I>Comfort Knitting &amp; Crochet: Afghans</I>, is Berroco&rsquo;s design director; her work has been published by almost all of the major yarn companies and knitting magazines in the industry. She lives in New Hampshire.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Stewart, Tabori & Chang
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4e775461